/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import { Notification } from 'element-ui';
import config from '../config/default';
import store from '@/store/index';
import route from '@/router/index';

/**
 * 创建axios实例
 */
export const service = axios.create({
  baseURL: config.baseUrl + '/admin',
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
  },
  withCredentials: false  // 凭证
})


/**
 * 请求前拦截
 */
service.interceptors.request.use(
  config => {
    if (config.method.toUpperCase() == 'POST') {
      config.data = QS.stringify({
        token: store.getters.userinfo.login_token || '',
        ...config.data
      })
    } else if (config.method.toUpperCase() == 'GET') {
      config.params = {
        token: store.getters.userinfo.login_token || '',
        ...config.params
      }
    }
    return config
  },
  error => {
    return Promise.error(error);
  }
);


/**
 * 响应拦截器
 */
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code == 200) {
        return Promise.resolve(response.data)
      } else if (response.data.code == 402) {
        Notification({
          title: `警告`,
          message: '已下线,请重新登录',
          type: 'error'
        });
        route.replace('login');
        return Promise.reject(response);
      } else {
        Notification({
          title: `警告`,
          message: response.data.error,
          type: 'error'
        });
        return Promise.reject(response);
      }
    } else {
      Notification({
        title: `警告`,
        message: `接收数据失败`,
        type: 'error'
      });
      return Promise.reject(response);
    }
  },
  // 响应状态码不是200的情况    
  error => {
    if (error && error.response && error.response.status) {
      Notification({
        title: `${error.response.status}警告`,
        message: `数据请求失败`,
        type: 'error'
      });
      return Promise.reject(error.response);
    } else {
      Notification({
        title: `警告`,
        message: `网络链接失败${error}`,
        type: 'error'
      });
      return Promise.reject();
    }
  }
);
